// actions.js

// Action Types
export const FETCH_ALTERNATIVE_PRODUCTS_REQUEST = 'FETCH_ALTERNATIVE_PRODUCTS_REQUEST';
export const FETCH_ALTERNATIVE_PRODUCTS_SUCCESS = 'FETCH_ALTERNATIVE_PRODUCTS_SUCCESS';
export const FETCH_ALTERNATIVE_PRODUCTS_FAILURE = 'FETCH_ALTERNATIVE_PRODUCTS_FAILURE';

// Post Alternative Products
export const POST_ALTERNATIVE_PRODUCTS_REQUEST = 'POST_ALTERNATIVE_PRODUCTS_REQUEST';
export const POST_ALTERNATIVE_PRODUCTS_SUCCESS = 'POST_ALTERNATIVE_PRODUCTS_SUCCESS';
export const POST_ALTERNATIVE_PRODUCTS_FAILURE = 'POST_ALTERNATIVE_PRODUCTS_FAILURE';

// Action Creators
export const fetchAlternativeProductsRequest = (variantId) => ({
  type: FETCH_ALTERNATIVE_PRODUCTS_REQUEST,
  payload: { variantId },
});

export const fetchAlternativeProductsSuccess = (data) => ({
  type: FETCH_ALTERNATIVE_PRODUCTS_SUCCESS,
  payload: { data },
});

export const fetchAlternativeProductsFailure = (error) => ({
  type: FETCH_ALTERNATIVE_PRODUCTS_FAILURE,
  payload: { error },
});

// Post Alternative Products - Action Creators
export const postAlternativeProductsRequest = (variantId, mfrItemCodes) => ({
  type: POST_ALTERNATIVE_PRODUCTS_REQUEST,
  payload: { variantId, mfrItemCodes },
});

export const postAlternativeProductsSuccess = (data) => ({
  type: POST_ALTERNATIVE_PRODUCTS_SUCCESS,
  payload: { data },
});

export const postAlternativeProductsFailure = (error) => ({
  type: POST_ALTERNATIVE_PRODUCTS_FAILURE,
  payload: { error },
});

